import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d9e9bb8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./styles.scss?vue&type=style&index=0&id=4d9e9bb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9e9bb8",
  null
  
)

export default component.exports